import pagoFacil from '@/assets/pagofacil.png';
import rapiPago from '@/assets/rapipago.png';
import { Button, Divider, Loader } from '@/components';
import usePinsAccount from '@/hooks/usePinsAccount';
import { useGetInitMyaccount } from '@/modules/my-account/hooks/useMyAccount';
import { redirectToPayU } from '@/services/myAccount';
import { formatToBalanceArs } from '@/utils';

interface Props {
  isHowTo: boolean;
}

const GetPins = () => {
  const { pinsData } = usePinsAccount();
  const { data } = useGetInitMyaccount();
  if (!data) return <Loader isVisible={true} />;
  if (!('usuario' in data)) return null;
  return (
    <>
      <li>Confirmá en esta pantalla el importe a pagar.</li>
      <li>Validá tus datos personales y confirmá la operación.</li>
      <li>
        Imprimí tu cupón, acercate a la sucursal más cercana y aboná el monto a
        pagar.
      </li>
      <li>
        En las próximas horas tendrás acreditado tu{' '}
        <strong>
          {pinsData.moneyToWallet
            ? 'saldo'
            : pinsData.selectedProduct?.descripcion}
        </strong>{' '}
        en Gran DT.
      </li>
    </>
  );
};

const HowTo = () => {
  const { pinsData } = usePinsAccount();
  return (
    <>
      <li>Confirmá en esta pantalla el importe a pagar.</li>
      <li>Validá tus datos personales y confirmá la operación.</li>
      <li>
        Imprimí tu cupón, acercate a la sucursal más cercana y aboná el monto a
        pagar.{' '}
      </li>
      <li>
        En las próximas horas tendrás acreditado tu{' '}
        {pinsData.moneyToWallet ? (
          'saldo'
        ) : (
          <strong>{pinsData.selectedProduct?.descripcion}</strong>
        )}{' '}
        en Gran DT.
      </li>
    </>
  );
};

export const PayWithPagoFacil = ({ isHowTo }: Props) => {
  const { pinsData } = usePinsAccount();
  const price = isHowTo
    ? pinsData.moneyToWallet
    : pinsData.selectedProduct?.precio;

  return (
    <div className="flex flex-col mb-10">
      <p className="text-gdt-gray text-base font-bold mx-auto">
        {isHowTo ? 'Carga saldo con' : 'Obtené tus pines con'}
      </p>
      <div className="flex flex-row items-center justify-center gap-[10px]">
        <img
          alt="pago facil"
          className="w-[60px] h-[60px] mt-3"
          src={pagoFacil}
        />
        <img alt="rapipago" className="w-[120px] mt-3" src={rapiPago} />
      </div>
      <Divider className="mb-[18px] mt-[8px] border-2" type="horizontal" />
      <ol className="list-decimal font-normal px-6 mb-6">
        {isHowTo ? <HowTo /> : <GetPins />}
      </ol>
      <div>
        <span className="mt-6 mb-5 text-gdt-blue font-bold text-center items-center justify-center text-sm">
          IMPORTE A PAGAR ${formatToBalanceArs(price ?? 0)}
        </span>
      </div>
      <Button
        className="w-full mt-4 lg:mx-[30px] lg:w-auto"
        type="button"
        variant="primary"
        onClick={() =>
          price &&
          redirectToPayU(price.toString(), pinsData.selectedProduct?.id)
        }
      >
        Confirmar
      </Button>
    </div>
  );
};
